import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';

import ButtonDeprecated, { BUTTON_THEME_YELLOW } from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const getFormFields = ({ activatingAccount }) => {
  return [
    {
      id: 'phone',
      type: 'phone',
      title: activatingAccount
        ? 'Enter your phone to activate your account'
        : 'Enter your phone to reset your password',
      label: "We'll text you a code to verify this number.",
      properties: {
        placeholder: '5121234567',
      },
      validations: ['required', 'phone'],
    },
  ];
};

class SrRequestPasswordResetSmsForm extends Component {
  static propTypes = {
    activatingAccount: PropTypes.bool,
    prefillPhone: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { activatingAccount, prefillPhone } = this.props;
    const initialValues = createInitialValues({
      formFields: getFormFields({ activatingAccount }),
      defaultValues: {
        phone: prefillPhone && prefillPhone.length === 10 ? prefillPhone : '',
      },
    });

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange={false}
        validate={createFormValidationFn(getFormFields({ activatingAccount }))}
        onSubmit={this.props.onSubmit}
        render={(formikBag) => {
          return (
            <Form>
              {getFormFields({ activatingAccount }).map((formField) => (
                <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
              ))}
              <ButtonDeprecated type="submit" theme={BUTTON_THEME_YELLOW}>
                next: enter code
              </ButtonDeprecated>
            </Form>
          );
        }}
      />
    );
  }
}

SrRequestPasswordResetSmsForm.displayName = 'SrRequestPasswordResetSmsForm';

export default SrRequestPasswordResetSmsForm;
